<!--
 * @Author: your name
 * @Date: 2021-06-22 13:58:42
 * @LastEditTime: 2021-06-23 10:06:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\views\home\components\EcHeaderHelp.vue
-->
<template>
  <div class="in-passWordChange">
    <div class="in-changePW flex-center" @click="help">
      <i class="el-icon-warning-outline ec-head-icon"></i>
      <p>{{ $t('navbar.about') }}</p>
    </div>
    <el-dialog
      v-dialogDrag
      :title="this.$t('navbar.about')"
      top="15%"
      width="450px"
      class="dialog--mini"
      :visible.sync="helpFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="version">
        <div class="version__imgwrap">
          <img src="../../../assets/img/u28.png" class="version__img" />
        </div>
        <div class="version__content">
          <h4>{{ $t('navbar.title') }}(v1.0.0)</h4>
          <div>{{ $t('navbar.versionName') }}{{ $t('navbar.title') }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: 'EcHeaderHelp',
      helpFormVisible: false
    }
  },
  methods: {
    help() {
      const _this = this
      _this.helpFormVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.version {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  &__imgwrap {
    width: 100px;
    margin-right: 10px;
  }
  &__img {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/EcHeaderHelp.vue